@import "../../../globalStyles/commons";

:host {
  display: block;
}

.sidenav-menu-item {
  cursor: pointer;
  @include font-style(text-md);
  padding: var(--spacing-02) var(--spacing-04);
  box-sizing: border-box;
  display: flex;
  align-items: center;
  gap: var(--spacing-02);
  color: var(--text-secondary);
  outline: none;

  .item-section {
    display: flex;
    align-items: center;
  }

  .slot-main {
    display: block;
    flex: 1;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }

  .slot-end {
    color: var(--text-helper);
  }

}



.menu-item {
  &:hover, &.has-focus:not(.active) {
    background: var(--hover-ui);
    color: var(--text-primary);
    .slot-end {
      color: var(--icon-01);
    }
  }

  &.active, &.selected {
    background: var(--selected-ui);
  }
}

.menu-item.has-focus:not(.active) {
  @include focus-ring;
}

.menu-item.disabled {
  cursor: not-allowed;
  color: var(--text-disabled) !important;
  background-color: var(--disabled-01) !important;

  &:hover, &.has-focus:not(.active) {
    color: var(--text-disabled) !important;
    background-color: var(--disabled-01) !important;
  }

  &.active, &.selected {
    color: var(--text-disabled) !important;
    background-color: var(--disabled-01) !important;
  }
}


.menu-item:not(.start-slot-has-content) {
  .slot-start {
    display: none;
  }
}

.menu-item:not(.end-slot-has-content) {
  .slot-end {
    display: none;
  }
}


